import React, { useReducer, useContext, useEffect, createContext } from 'react'
// import * as Utils from './utils'

const APP_STORE_ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SET_ONLINE: 'SET_ONLINE',
  SHOW_ALERT: 'SHOW_ALERT',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  SET_LOGIN_WITH_TOKEN: 'SET_LOGIN_WITH_TOKEN',
  SET_SITE_SETTINGS: 'SET_SITE_SETTINGS',
  RESTORE: 'RESTORE',
  AUTO_TRANSFER: 'AUTO_TRANSFER',
  REFRESH_WALLET_AMOUNT: 'REFRESH_WALLET_AMOUNT',
  REFRESH_GET_GAME_WALLET: 'REFRESH_GET_GAME_WALLET',
  SET_CURRENCY_FORMAT: 'SET_CURRENCY_FORMAT',
  SET_UNREAD_NOTI: 'SET_UNREAD_NOTI',
  SET_SHOPPING_CART_DIALOG: 'SET_SHOPPING_CART_DIALOG',
  SET_TOTAL_CART_COUNT: 'SET_TOTAL_CART_COUNT',
  SET_SELECTED_ADDRESS: 'SET_SELECTED_ADDRESS',
  SET_ADDRESS: 'SET_ADDRESS',
  SET_CHECK_ADDRESS: 'SET_CHECK_ADDRESS'

}

const StoreStateContext = createContext()
const StoreDispatchContext = createContext()

const initialState = {
  loggedIn: false,
  loginWithToken: true,
  online: true,
  schema: [],
  alert: {
    open: false,
    title: '',
    description: '',
    forwardUrl: '',
    typeAlert: ''
  },
  user: {
  },
  menu: ['HOME', 'SHOP', 'HOW_IT_WORK', 'WEBSITE'],
  footer: [],
  gameProvidersByType: {
    // "SL":["GP","PP","JL","HB","PNG","NT"],
    // "LC":["AB","AG","BG","DG"],
    // "FI":["JL","SG","YGR"],
    // "LO":["QQK"],
    // "SP":["CMD","IBC"]
  },
  gameProviders: {
  },
  currency: '',
  cancelPromotion: false,
  registration: {},
  socialMedia: [],
  gameWallet: [],
  unreadNotiCount: 0,
  currencyFormat: {
    conversion_factor: 1,
    locale: 'en-US',
    prefix: '',
    postfix: 'MYR',
    min_deposit_amount: 0,
    max_deposit_amount: 0,
    default_deposit_amounts: [],
    min_transfer_amount: 0,
    max_transfer_amount: 0,
    decimal_point: 2
  },
  timezone: 'Asia/Kuala_Lumpur',
  enableMall: false,
  mallUrl: '',
  enableAffiliate: false,
  affiliateUrl: '',
  shoppingCartDialog: { open: false, cart: '' },
  totalCartCount: 0,
  selectedAddress: {},
  address: [],
  checkAddress: false,
  tenant: '',
  loyaltyDecimalPoint: 0
};

function storeReducer(state, action) {
  switch (action.type) {
    case APP_STORE_ACTION.LOGIN: {
      const { user } = action.payload

      return { ...state, loginWithToken: true, loggedIn: true, user };
    }

    case APP_STORE_ACTION.SET_CHECK_ADDRESS: {

      return { ...state, checkAddress: action.payload };
    }

    case APP_STORE_ACTION.SET_ADDRESS: {
      console.log('full address', action.payload)
      const address = action.payload
      return { ...state, address: action.payload, selectedAddress: address.length > 0 ? address[0] : {} };
    }

    case APP_STORE_ACTION.SET_SELECTED_ADDRESS: {
      console.log('selected address', action.payload)
      return { ...state, selectedAddress: action.payload };
    }

    case APP_STORE_ACTION.SET_TOTAL_CART_COUNT: {
      return { ...state, totalCartCount: action.payload };
    }

    case APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG: {
      let totalCartQuantity = 0
      let totalCartPoint = 0
      if (typeof action.payload === 'boolean' && action.payload === false) {
        return { ...state, shoppingCartDialog: { open: false, cart: "[]" } }
      } else {
        const getCart = JSON.parse(action.payload?.cart)
        totalCartQuantity = getCart?.reduce((total, item) => total + item.cart_quantity, 0);


        // console.log('totalCartQuantity', totalCartQuantity)
      }

      return { ...state, shoppingCartDialog: action.payload, totalCartCount: totalCartQuantity };
    }

    case APP_STORE_ACTION.SET_UNREAD_NOTI: {
      return { ...state, unreadNotiCount: action.payload };
    }

    case APP_STORE_ACTION.SET_CURRENCY_FORMAT: {
      return { ...state, currencyFormat: action.payload };
    }

    case APP_STORE_ACTION.REFRESH_GET_GAME_WALLET: {
      return { ...state, gameWallet: action.payload };
    }

    case APP_STORE_ACTION.REFRESH_WALLET_AMOUNT: {
      return { ...state, user: { ...state.user, wallet_amount: action.payload } };
    }

    case APP_STORE_ACTION.AUTO_TRANSFER: {
      return { ...state, user: { ...state.user, auto_restore: action.payload } };
    }

    case APP_STORE_ACTION.LOGOUT:
      return { ...state, loginWithToken: false, loggedIn: false, user: null };

    case APP_STORE_ACTION.UNAUTHENTICATED: {
      return { ...state, loginWithToken: false, alert: { type: APP_STORE_ACTION.UNAUTHENTICATED, open: true, title: 'Unauthenticated', description: 'No Access Token, Please Login Again', typeAlert: 'error' } }
    }

    case APP_STORE_ACTION.SET_SITE_SETTINGS: {
      const { registration, dataTypes, currency, footer, timezone, cancelPromotion, enableMall, mallUrl, pageLoadAutoRestore, domain, tenant, country, enableLoyaltyDecimalPoint,enableMallProductQuantityVisibility } = action.payload

      const checkLoyaltyDecimalPoint = enableLoyaltyDecimalPoint ? 2 : 0
      return {
        ...state, registration, dataTypes, currency, footer, timezone, cancelPromotion, enableMall, mallUrl, pageLoadAutoRestore, domain, tenant, country, loyaltyDecimalPoint: checkLoyaltyDecimalPoint,enableMallProductQuantityVisibility
      }
    }

    case APP_STORE_ACTION.SET_ONLINE: {
      return { ...state, online: action.payload }
    }

    case APP_STORE_ACTION.SHOW_ALERT: {

      if (typeof action.payload === 'boolean' && action.payload === false) {
        return { ...state, alert: { open: false, title: '', description: '', forwardUrl: '' } }
      }

      if (state.alert.open) {
        return state
      }

      return { ...state, alert: { open: true, title: action.payload.title ?? '', description: action.payload.description ?? '', forwardUrl: action.payload.forwardUrl ?? '' } }
    }



    case APP_STORE_ACTION.SET_LOGIN_WITH_TOKEN: {
      return { ...state, loginWithToken: action.payload }
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function StoreProvider({ children }) {
  const [state, dispatch] = useReducer(storeReducer, initialState)

  useEffect(() => {
    const controller = new AbortController();

    const _onOnlineStatus = () => {
      dispatch({ type: APP_STORE_ACTION.SET_ONLINE, payload: navigator.onLine })
    }

    dispatch({ type: APP_STORE_ACTION.SET_ONLINE, payload: navigator.onLine })

    window.addEventListener('offline', _onOnlineStatus, { signal: controller.signal });
    window.addEventListener('online', _onOnlineStatus, { signal: controller.signal });

    return () => {
      controller.abort();
    }
  }, [])

  return (
    <StoreStateContext.Provider value={state}>
      <StoreDispatchContext.Provider value={dispatch}>
        {children}
      </StoreDispatchContext.Provider>
    </StoreStateContext.Provider>
  )
}

function useStoreState() {
  const context = useContext(StoreStateContext)
  if (context === undefined) {
    throw new Error('useStoreState must be used within a StoreProvider')
  }
  return context
}

function useStoreDispatch() {
  const context = useContext(StoreDispatchContext)
  if (context === undefined) {
    throw new Error('useStoreDispatch must be used within a StoreProvider')
  }
  return context
}

export { StoreProvider, useStoreState, useStoreDispatch, APP_STORE_ACTION }